export const defaultErrorMessage =
  'It seems that something went wrong. Please try again in a few moments.';
export const defaultNetworkErrorMessage =
  'There was an error while fetching data, please try again in a few moments.';
